import { defineComponent as _defineComponent } from 'vue'
import CatalogCategoryItem from '~/components/sections/categorySection/CatalogCategoryItem.vue';

interface Props {
  data: {
    id?: string;
    items: any[];
  };
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CatalogCategories',
  props: {
    data: { default: () => ({
    items: [],
  }) }
  },
  setup(__props: any) {

const grid = {
  cols: 'grid-cols-1 sm:grid-cols-6',
  rows: 'auto-rows-[296px] sm:auto-rows-[456px]',
  span: {
    1: 'col-span-1 sm:col-span-2',
    1.5: 'col-span-1 sm:col-span-3',
  } as Record<number, string>,
};



return { __sfc: true,grid, CatalogCategoryItem }
}

})